
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/upgrade-to-native-color",
      function () {
        return require("private-next-pages/material-ui/migration/upgrade-to-native-color.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/upgrade-to-native-color"])
      });
    }
  